<template>
	<div>
		<v-btn
				class="rounded"
				:class="{
					'v-btn--active': editor.isFocused && editor.isActive('link')
				}"
				:color="editor.isFocused && editor.isActive('link') ? 'primary' : 'transparent'"
				depressed
				fab
				small
				@click="setLink"
				@mousedown.stop.prevent
		>
			<v-icon v-if="!editor.isFocused" key="link">
				mdi-link
			</v-icon>
			<v-icon v-else-if="editor.isFocused && editor.isActive('link')" key="edit-link">
				mdi-link-edit
			</v-icon>
			<v-icon v-else-if="editor.isFocused && !editor.isActive('link')" key="add-link">
				mdi-link-plus
			</v-icon>
		</v-btn>
		<v-btn
				v-if="editor.isActive('link')"
				class="ms-2 rounded"
				color="transparent"
				depressed
				:disabled="!editor.isActive('link')"
				fab
				small
				@click="editor.chain().focus().unsetLink().run()"
				@mousedown.stop.prevent
		>
			<v-icon>
				mdi-link-off
			</v-icon>
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'Link',
	props: {
		editor: Object
	},
	methods: {
		setLink() {
			const previousUrl = this.editor.getAttributes('link').href;
			const url = window.prompt('URL', previousUrl);

			// cancelled
			if(url === null) return;

			// empty
			if(url === '') {
				this.editor
						.chain()
						.focus()
						.extendMarkRange('link')
						.unsetLink()
						.run();

				return;
			}

			// update link
			this.editor
					.chain()
					.focus()
					.extendMarkRange('link')
					.setLink({ href: url })
					.run();
		}
	}
}
</script>

<style lang="scss" scoped>
.v-btn {
	transition-duration: 0.28s;
	transition-property: background-color, box-shadow, color, transform, opacity;
	transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
</style>